import { Tooltip, TooltipProps, Typography } from 'antd'
import { TextProps } from 'antd/es/typography/Text'
import dayjs from 'dayjs'

const { Text } = Typography

interface Props {
  date?: string
  tooltipProps?: TooltipProps
  textProps?: TextProps
}

const SBNiceDate = ({ date, textProps, tooltipProps }: Props) =>
  date ? (
    <Tooltip
      title={dayjs(date).format('YYYY-MM-DD HH:mm:ss')}
      {...tooltipProps}
    >
      <Text {...textProps}>{dayjs(date).fromNow()}</Text>
    </Tooltip>
  ) : (
    <Text>--</Text>
  )

export default SBNiceDate
